import { render } from "./ContactsVue.vue?vue&type=template&id=3508aa34"
import script from "./ContactsVue.vue?vue&type=script&lang=js"
export * from "./ContactsVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__